import {
  GET_LIST_DANHSACHKHACHHANG,
  GET_LIST_DANHSACHKHACHHANG_SUCCESS,
  GET_LIST_DANHSACHKHACHHANG_FAILURE,
} from "actions/DanhSachKhachHang/actionTypes";

const initialState = {
  getListDanhSachKhachHangLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListDanhSachKhachHang = (state, action) => ({
  ...state,
  getListDanhSachKhachHangLoading: true,
});

const getListDanhSachKhachHangSuccess = (state, action) => {
  return {
    ...state,
    getListDanhSachKhachHangLoading: false,
    objList: action.payload,
  };
};

const getListDanhSachKhachHangFailed = (state, action) => ({
  ...state,
  getListDanhSachKhachHangLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHKHACHHANG:
      return getListDanhSachKhachHang(state, action);
    case GET_LIST_DANHSACHKHACHHANG_SUCCESS:
      return getListDanhSachKhachHangSuccess(state, action);
    case GET_LIST_DANHSACHKHACHHANG_FAILURE:
      return getListDanhSachKhachHangFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
